import { useState } from 'react';
import { getFirestore, doc, setDoc, Timestamp } from 'firebase/firestore';
import { Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import './XDocList';
import QRCode from 'react-qr-code';

const ClubAccess = ({ memberEmail, memberName, onSendToParent }) => {
  const db = getFirestore();
  
  const getLogsCollectionName = (date = new Date()) => {
    const year = date instanceof Date ? date.getFullYear() : new Date().getFullYear();
    return `access_logs_${year}`;
  };

  const getActiveShiftDateStr = (date = new Date()) => {
    const d = new Date(date);
    if (d.getHours() < 2) {
      d.setDate(d.getDate() - 1);
    }
    return d.toISOString().split('T')[0];
  };

  const [isLogging, setIsLogging] = useState(false);

  const handleAction = async () => {
    if (isLogging) return;
    setIsLogging(true);
    const ts = new Date();
    try {
      const shiftDateStr = getActiveShiftDateStr(ts);
      const cleanEmail = memberEmail ? memberEmail.toLowerCase().trim() : "";
      
      const docId = `${shiftDateStr}_${cleanEmail}`;
      const logDocRef = doc(db, getLogsCollectionName(ts), docId);

      const resolvedName = memberName || localStorage.getItem("user") || cleanEmail;

      const initialScanEvent = {
        timestamp: Timestamp.fromDate(ts),
        method: "Self Checkin",
        type: "Member",
        status: "active",
        isVerified: false,
        isBypassed: false,
        verifier: cleanEmail
      };

      await setDoc(logDocRef, {
        fullName: resolvedName,
        entryType: "Member",
        method: "Self Checkin",
        rawPayload: cleanEmail,
        signedInBy: cleanEmail,
        sponsorName: resolvedName,
        scannedAt: Timestamp.fromDate(ts),
        lastScannedAt: Timestamp.fromDate(ts),
        status: "active",
        isVerified: false,
        isExpired: false,
        isFlagged: false,
        hasIncident: false,
        scans: [initialScanEvent]
      }, { merge: true });

      if (typeof onSendToParent === 'function') {
        onSendToParent(true);
      }
    } catch (e) {
      console.error("Self Checkin Error:", e);
      toast.error("Log failed");
    } finally {
      setIsLogging(false);
    }
  };

  return (
    <Button onClick={handleAction}>
      <div className="image-focus-wrapper hoverX">
        <QRCode value={memberEmail} size={50} className="" bgColor="transparent" fgColor={"#0b0b0b"} level="M" />
      </div>
      <span className="orange"><strong>Self Check In</strong></span>
    </Button>
  );
};

export default ClubAccess;